/* eslint-disable no-confusing-arrow */
import React, { useState } from "react"
import {
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Button,
  Row,
  Col,
  Alert
} from "reactstrap"
// import { Link } from "react-router-dom"
// import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer"
import { PDFDownloadLink } from "@react-pdf/renderer"
// import XLSX from "xlsx"
// import moment from "moment"
import { useMutation } from "@apollo/react-hooks"
import { useQueryData } from "utils"
import DetailItemList from "components/order-detail-item-list"
import { PrintOrderPDF } from "components/utility"
import DetailItem from "components/order-detail-item"
import { Spinner, BarLoader } from "components/spinner"
import DetailHeader from "components/order-detail-header"
import { withBasicNotify } from "components/notification"
import { GET_ORDER, UPDATE_ORDER } from "../gql"

document.body.scrollTop = 0 // For Safari
document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera

const OrderClContainer = (props) => {
  const orderId = props.match.params.id
  const { data, loading, error } = useQueryData(GET_ORDER, {
    skip: !orderId,
    variables: { id: orderId },
    fetchPolicy: "cache-and-network"
  })

  const [clientOrderNumber, setClientOrderNumber] = useState(
    data?.order?.clientOrderNumber
  )

  const [isCounting, setIsCounting] = useState(false)
  const [showDownloadButton, setShowDownloadButton] = useState(false)
  const [generateQuoteText, setGenerateQuoteText] = useState("產生報價單")

  const [
    updateOrder,
    { loading: updateOrderLoading, error: updateOrderError }
  ] = useMutation(UPDATE_ORDER)

  if (loading) {
    return <Spinner />
  }

  if (error) {
    return <Alert color="danger">錯誤訊息：{`${error}`}</Alert>
  }

  const variableFromData = () => {
    return {
      id: orderId,
      input: { status: data.order.status, clientOrderNumber }
    }
  }

  const startCountDown = (counter) => {
    setGenerateQuoteText(`報價單產生中 (${counter})`)
    if (counter > 0) {
      setTimeout(() => {
        startCountDown(counter - 1)
      }, 1000)
    } else {
      setIsCounting(false)
      setGenerateQuoteText("產生報價單")
      setShowDownloadButton(true)
      // props.history.push(`/order/maintain-order/pdf/${orderId}`)
    }
  }

  return (
    <div>
      <DetailHeader
        data={data}
        onCustomOrderNumberChange={(e) => setClientOrderNumber(e.target.value)}
        onCustomOrderNumberSave={async () => {
          await updateOrder({
            variables: variableFromData()
          })
          props.notify.success("訂單更新成功")
        }}
      />
      <Card>
        <CardHeader>
          <Row style={{ display: "flex", alignItems: "center" }}>
            <Col>
              <i className="mdi mdi-information-outline mr-2"> </i> 商品資訊
            </Col>
          </Row>
        </CardHeader>
        <CardBody>
          <DetailItemList
            renderItems={() =>
              data?.order?.orderDetails.map((orderDetail) => (
                <DetailItem
                  key={orderDetail.id}
                  orderDetails={data.order.orderDetails}
                  orderDetail={orderDetail}
                  readOnly={true}
                  isAssistant={false}
                />
              ))
            }
            readOnly
          />
        </CardBody>
        <CardFooter>
          <Row style={{ display: "flex", alignItems: "center" }}>
            <Col>
              {data?.order && !showDownloadButton && (
                <Button
                  color="success"
                  className="ml-2 mr-2"
                  disabled={isCounting}
                  onClick={() => {
                    setIsCounting(true)
                    startCountDown(6)
                  }}
                >
                  {generateQuoteText}
                </Button>
              )}
              {showDownloadButton && (
                <PDFDownloadLink
                  document={<PrintOrderPDF order={data.order} />}
                  fileName={`${data.order.orderNumber}.pdf`}
                >
                  {/* eslint-disable-next-line no-unused-vars */}
                  {({ blob, url, loading, error }) => (
                    <Button color="success" className="ml-2 mr-2">
                      下載報價單
                    </Button>
                  )}
                </PDFDownloadLink>
              )}
            </Col>
          </Row>
        </CardFooter>
        <BarLoader loading={updateOrderLoading} />
      </Card>
      {updateOrderError && (
        <Alert color="danger">錯誤訊息：{`${updateOrderError.message}`}</Alert>
      )}
    </div>
  )
}

export default withBasicNotify(OrderClContainer)
